"use client";

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { LandingHeader } from '@/app/components/LandingHeader';
import { Footer } from '@/app/components/Footer';
import { PricingSection } from '@/app/components/PricingSection';
import { Button } from '@/app/components/ui/Button';
import { Check, ArrowRight } from 'lucide-react';

export default function AboutUsPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground font-body">
      <LandingHeader transparent />
      
      <main className="flex-1">
        
        {/* HERO SECTION: Mission Statement */}
        <section className="relative pt-32 pb-24 px-6 bg-white border-b border-foreground/10">
          <div className="container mx-auto max-w-5xl">
            {/* Header & Quote */}
            <div className="mb-24">
              <h1 className="font-display text-5xl md:text-7xl mb-12 tracking-tighter">
                Our <span className="text-teal">Mission</span>
              </h1>
              <p className="text-2xl md:text-3xl font-medium text-foreground leading-tight max-w-4xl italic">
                &quot;To make Will writing accessible, affordable, and easy for everyone in the UK. No hidden fees, no complicated jargon.&quot;
              </p>
            </div>

            {/* Context Content Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
              
              <div className="space-y-8 text-lg md:text-xl font-light leading-relaxed text-muted-foreground">
                <p>
                  Like many people, we put off writing our wills for years. It felt daunting, expensive, and frankly, a bit morbid. When we finally looked into it, we were shocked by the solicitor fees for what seemed like a straightforward document.
                </p>
                <p>
                  We realised that for the vast majority of people, a simple, legally binding will doesn&apos;t need to be complicated. The legal requirements are clear, but the industry often shrouds them in mystery and high costs.
                </p>

                <div className="pt-8 space-y-4">
                  <div className="flex items-center gap-4">
                    <div className="w-6 h-6 bg-teal text-white flex items-center justify-center shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span className="text-foreground font-medium text-lg">No legal jargon</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-6 h-6 bg-teal text-white flex items-center justify-center shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span className="text-foreground font-medium text-lg">Affordable flat fee</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-6 h-6 bg-teal text-white flex items-center justify-center shrink-0">
                      <Check className="w-4 h-4" />
                    </div>
                    <span className="text-foreground font-medium text-lg">Every will professionally reviewed</span>
                  </div>
                </div>
              </div>

              <div className="relative h-[600px] w-full">
                <Image 
                  src="/draftwill imagery/about/mission.jpg" 
                  alt="Our Founder" 
                  fill
                  className="object-cover grayscale hover:grayscale-0 transition-all duration-700"
                />
              </div>

            </div>
          </div>
        </section>


        {/* PRICING SECTION: Clean & Sharp */}
        <PricingSection />

      </main>

      <Footer />
    </div>
  );
}
